export const printReceipt = async (printerIp, printerPort, receiptLines) => {
  const url = `http://${printerIp}:${printerPort}/cgi-bin/epos/service.cgi?devid=local_printer&timeout=10000`;

  const requestXml = formatReceiptXml(receiptLines);
  try {
    await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "text/xml; charset=utf-8" },
      body: requestXml,
    });
  } catch (error) {
    console.error("Print error ", error);
  }
};

const formatReceiptXml = (receiptLines) => {
  const LINE_WIDTH = 42;
  const LABEL_WIDTH = 20;
  const VALUE_WIDTH = 22;

  const formatLine = (label, value) => {
    const paddedLabel = label.padEnd(LABEL_WIDTH, " ");
    const paddedValue = String(value).padStart(VALUE_WIDTH, " ");
    return `<text font="font_b">${paddedLabel}${paddedValue}</text><feed line="1"/>`;
  };

  let lines = "";

  lines += `<text align="center" font="font_a" smooth="true" width="2" height="2">RECEIPT</text><feed line="1"/>`;

  lines += `<text font="font_b" width="1" height="1"></text><feed line="1"/>`;

  lines += formatLine("RECEIPT ID", `${receiptLines?.receiptId || ""}`);
  lines += formatLine(
    "ORDER ID / DATE",
    `${receiptLines?.orderId || ""} / ${receiptLines?.receiptDate || ""}`
  );
  lines += formatLine("COMPANY NAME", receiptLines?.storeName || "");
  lines += formatLine("NAME", receiptLines?.name || "");

  lines += formatLine(
    "Delivery Method",
    receiptLines?.deliveryMethodName[0] || ""
  );
  lines += formatLine(
    "Delivery Partner",
    receiptLines?.deliveryPartnerName[0] || ""
  );

  lines += `<text font="font_b">${"-".repeat(
    LINE_WIDTH
  )}</text><feed line="1"/>`;

  const totalAmount = parseFloat(receiptLines?.totalAmount || "0");
  const paymentMethod = receiptLines?.paymentMethod || "";
  const status = receiptLines?.status || "";
  const paymentAmount = parseFloat(receiptLines?.paymentAmount || "0");

  lines += `<text font="font_b">PAYMENT DETAILS</text><feed line="1"/>`;
  lines += formatLine("Total Amount", `${totalAmount?.toFixed(2)}/-`);
  lines += formatLine("Payment Method", paymentMethod);
  lines += formatLine("Payment Status", status);
  lines += formatLine("Payment Amount", paymentAmount?.toFixed(2));

  lines += `<text font="font_b">${"-".repeat(
    LINE_WIDTH
  )}</text><feed line="1"/>`;

  lines += `<text font="font_b">Thank You for Shopping !!</text><feed line="1"/>`;

  lines += `<feed line="3"/>`;
  lines += `<cut />`;

  return (
    '<?xml version="1.0" encoding="utf-8"?>' +
    '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">' +
    "<s:Body>" +
    '<epos-print xmlns="http://www.epson-pos.com/schemas/2011/03/epos-print">' +
    lines +
    "</epos-print>" +
    "</s:Body>" +
    "</s:Envelope>"
  );
};
